export const VERSION_APP = '1.0.1';
export const HOME_DIR = '/';
export const ENV = {
    PROD: {
        API_BASE_URL1: 'https://script.google.com/macros/s/AKfycbzPlnRQdL8pjU_-2Y23EKFRj6C50UtK_jGgSWxjR43fkPJketK_pdOdwR8AONQmoLxb/exec',
        LIFF_ID1: '2011075437-7cs30rSv',
        FLEX_IMAGE1: 'https://i.postimg.cc/52dBsyr2/1280x640.png'
    }
}

export const CURRENT_ENV = ENV.PROD;